export const NAVIGATION = {
  HOME: "/FriendlyBets",
  ABOUT: "/about",
  CONTACT: "/contact",
  LOGIN: "/login",
  MYBETS: "/MyBets",
  ADDFRIENDS: "/addFriends",
  LEADERBOARD: "/leaderboard",
  RIVALRIES: "/rivalries",
  CHALLENGES: "/challenges",
  NOTIFICATIONS: "/Notifications",
  REGISTER: "/register",
};

export const LOCALSTORAGE = {
  USERS: "ALL_USERS",
  BETS: "BETS", // TODO: Change to BETS
  LOGGEDINUSER: "LOGGEDIN_USER",
  FRIENDREQUEST: "FRIEND_REQUEST",
  SELECTEDGAME: "SELECTED_GAME",
  ADMIN_MESSSAGES: "ADMIN_MESSAGES",
  ADMIN_MANAGEMENT: "ADMIN_MANAGEMENT",
};

export default {
  NAVIGATION,
  LOCALSTORAGE,
};
